import { render, staticRenderFns } from "./StationsWelcome.vue?vue&type=template&id=74cf9ee4&"
import script from "./StationsWelcome.vue?vue&type=script&lang=js&"
export * from "./StationsWelcome.vue?vue&type=script&lang=js&"
import style0 from "./StationsWelcome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports